import { render } from "./SzForm.vue?vue&type=template&id=11cb9e6f&scoped=true"
import script from "./SzForm.vue?vue&type=script&lang=ts"
export * from "./SzForm.vue?vue&type=script&lang=ts"

import "./SzForm.vue?vue&type=style&index=0&id=11cb9e6f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-11cb9e6f"

export default script